import React from 'react';

import { CompanyHubIcon } from '@atlaskit/temp-nav-app-icons/company-hub';
import { Flex } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

import { NavLogo } from '@atlassian/navigation-system/top-nav';

import { useCompanyHubName } from '@confluence/company-hub-utils/entry-points/useCompanyHubName';
import { COMPANY_HUB } from '@confluence/named-routes';

/**
 * The {@link https://staging.atlassian.design/components/navigation-system/top-navigation/examples#navigation-logo | navigation logo} of the Company Hub app-like experience at Team '25 US.
 *
 * Inspired by `SiteLogoButton` at confluence/next/packages/app-navigation/src/SiteLogoButton.tsx
 *
 * @see {@link https://www.figma.com/design/MBdUXhdmgbsIkMkOhQGu5e/Hub-App?node-id=101-52260}
 * @see {@link https://hello.atlassian.net/wiki/spaces/CLI/pages/4856024337/Confluence-less+Team+25+US+Experience}
 */
export const CompanyHubSiteLogoButton = () => {
	const companyHubName = useCompanyHubName();

	return (
		<NavLogo
			href={COMPANY_HUB.toUrl()}
			icon={CompanyHubNavIcon}
			label={companyHubName}
			logo={CompanyHubNavLogo}
		/>
	);
};

/**
 * The navigation logo at small viewport widths.
 */
const CompanyHubNavIcon = () => <CompanyHubIcon size="24" />;

/**
 * The navigation logo at large viewport widths.
 */
function CompanyHubNavLogo() {
	const companyHubName = useCompanyHubName();

	return (
		<Flex gap="space.075" alignItems="center">
			<CompanyHubIcon size="24" />
			<svg width="320" height="32" viewBox="0 0 320 32">
				<text
					dominantBaseline="central"
					x="0"
					y="50%"
					fill={token('color.text')}
					fontFamily={token('font.family.heading')}
					fontSize={token('font.heading.xsmall')}
					fontWeight={token('font.weight.bold')}
				>
					{companyHubName}
				</text>
			</svg>
		</Flex>
	);
}
